import type { Voucher } from '../../domain/types'
import type { VouchersAPIResponse } from '../types'

export function mapVouchers(response: VouchersAPIResponse): Record<string, Voucher> {
  const vouchers = response.data.vouchers
    .filter(v => v.isActive && v.canBeUsed && v.amountPending.amount > 0)
    .reduce((acc, voucher) => {
      acc[voucher.voucherCode] = {
        voucherCode: voucher.voucherCode,
        amount: voucher.amountPending.amount,
        expirationDate: voucher.expirationDate,
      }

      return acc
    }, {} as Record<string, Voucher>)

  return vouchers
}
